	<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="21"
						viewBox="0 0 20 21"
						fill="none"
					>
						<path
							d="M18.3333 9.73355V10.5002C18.3323 12.2972 17.7504 14.0458 16.6744 15.4851C15.5984 16.9244 14.086 17.9773 12.3628 18.4868C10.6395 18.9963 8.79768 18.9351 7.11202 18.3124C5.42636 17.6896 3.98717 16.5386 3.00909 15.0311C2.03101 13.5236 1.56645 11.7403 1.68469 9.94714C1.80293 8.15402 2.49763 6.44715 3.66519 5.08111C4.83275 3.71506 6.41061 2.76303 8.16345 2.367C9.91629 1.97097 11.7502 2.15216 13.3916 2.88355"
							stroke="#32DFA7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M18.3333 3.8335L10 12.1752L7.5 9.67516"
							stroke="#32DFA7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>